(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-community-slider]');
    if (!section) return;
    var track = section.querySelector('[data-community-track]');
    var prevBtn = section.querySelector('[data-community-prev]');
    var nextBtn = section.querySelector('[data-community-next]');
    if (!track) return;
    var cards = track.querySelectorAll('.community__card');
    if (cards.length === 0) return;

    var currentIndex = 0;
    var cardWidth = 0;
    var gap = 16;
    var visibleCount = 3;
    var maxIndex = 0;

    function measure() {
      if (cards.length === 0) return;
      cardWidth = cards[0].offsetWidth;
      var wrapper = track.parentElement;
      var w = wrapper ? wrapper.offsetWidth : window.innerWidth;
      if (w <= 640) visibleCount = 1;
      else if (w <= 900) visibleCount = 2;
      else if (w <= 1200) visibleCount = 3;
      else visibleCount = 4;
      maxIndex = Math.max(0, cards.length - visibleCount);
      currentIndex = Math.min(currentIndex, maxIndex);
      update();
    }

    function update() {
      var offset = -(currentIndex * (cardWidth + gap));
      track.style.transform = 'translateX(' + offset + 'px)';
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    if (prevBtn) prevBtn.addEventListener('click', function() {
      if (currentIndex > 0) {
        currentIndex--;
        update();
      }
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        update();
      }
    });

    window.addEventListener('resize', measure);
    measure();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderController {
    constructor() {
      this.drawer = document.getElementById('drawer-menu');
      this.search = document.getElementById('search-modal');
      this.cartDrawer = document.getElementById('cart-drawer');
      this.body = document.body;
      this.shippingThreshold = this.cartDrawer ? parseInt(this.cartDrawer.dataset.shippingThreshold, 10) || 10000 : 10000;
      this.translations = {};
      const transEl = document.getElementById('header-translations');
      if (transEl) try { this.translations = JSON.parse(transEl.textContent); } catch (e) {}
      
      this.init();
    }

    init() {
      this.bindDrawerEvents();
      this.bindSearchEvents();
      this.bindCartDrawerEvents();
      this.bindMegaMenuEvents();
      this.bindKeyboardEvents();
      document.addEventListener('cart:item-added', () => {
        this.openCartDrawer();
        this.refreshCartDrawer();
      });
    }

    // Drawer Menu
    bindDrawerEvents() {
      const openButtons = document.querySelectorAll('[data-drawer-open]');
      const closeButtons = document.querySelectorAll('[data-drawer-close]');

      openButtons.forEach(btn => {
        btn.addEventListener('click', () => this.openDrawer());
      });

      closeButtons.forEach(btn => {
        btn.addEventListener('click', () => this.closeDrawer());
      });
    }

    openDrawer() {
      this.drawer.setAttribute('aria-hidden', 'false');
      this.body.style.overflow = 'hidden';
      
      const toggle = document.querySelector('[data-drawer-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');

      // Focus first link + update drawer mega slider indicator (show hint/fade only when scrollable)
      setTimeout(() => {
        const firstLink = this.drawer.querySelector('a');
        if (firstLink) firstLink.focus();
        this.drawer.querySelectorAll('.drawer-menu__mega-slider-wrap').forEach((wrap) => {
          const grid = wrap.querySelector('[data-drawer-mega-slider]');
          const hint = wrap.querySelector('.drawer-menu__mega-scroll-hint');
          const fade = wrap.querySelector('.drawer-menu__mega-fade');
          if (grid && hint && fade) {
            const scrollable = grid.scrollWidth > grid.clientWidth;
            hint.style.display = scrollable ? '' : 'none';
            fade.style.display = scrollable ? '' : 'none';
          }
        });
      }, 400);
    }

    closeDrawer() {
      this.drawer.setAttribute('aria-hidden', 'true');
      this.body.style.overflow = '';
      
      const toggle = document.querySelector('[data-drawer-open]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    }

    // Mega menu: keep open when hovering the panel (panel is position:fixed so :hover is lost)
    bindMegaMenuEvents() {
      const wrappers = document.querySelectorAll('[data-mega-wrapper]');
      wrappers.forEach((wrapper) => {
        const link = wrapper.querySelector('.header__nav-link');
        const panel = wrapper.querySelector('[data-mega-panel]');
        const content = panel?.querySelector('.header__mega-content');
        if (!link || !panel || !content) return;
        let closeTimeout = null;
        const open = () => {
          clearTimeout(closeTimeout);
          wrapper.classList.add('mega-open');
        };
        const close = () => {
          closeTimeout = setTimeout(() => wrapper.classList.remove('mega-open'), 280);
        };
        link.addEventListener('mouseenter', open);
        link.addEventListener('mouseleave', close);
        content.addEventListener('mouseenter', open);
        content.addEventListener('mouseleave', close);
      });
    }

    // Search Modal (no-op if modal was removed)
    bindSearchEvents() {
      if (!this.search) return;
      const openButtons = document.querySelectorAll('[data-search-open]');
      const closeButtons = document.querySelectorAll('[data-search-close]');
      const searchInput = document.querySelector('[data-search-input]');

      openButtons.forEach(btn => {
        btn.addEventListener('click', () => this.openSearch());
      });

      closeButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeSearch();
        });
      });

      // Predictive search (debounced)
      if (searchInput) {
        let timeout;
        searchInput.addEventListener('input', (e) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            this.handleSearch(e.target.value);
          }, 300);
        });
      }
    }

    openSearch() {
      if (!this.search) return;
      this.search.setAttribute('aria-hidden', 'false');
      this.body.style.overflow = 'hidden';
      
      const toggle = document.querySelector('[data-search-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');

      // Focus input
      setTimeout(() => {
        const input = this.search.querySelector('[data-search-input]');
        if (input) input.focus();
      }, 400);
    }

    closeSearch() {
      const modal = this.search;
      if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
      const toggle = document.querySelector('[data-search-open]');
      modal.classList.add('search-modal--closing');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      const duration = 300;
      setTimeout(() => {
        modal.classList.remove('search-modal--closing');
        modal.setAttribute('aria-hidden', 'true');
        this.body.style.overflow = '';
        if (toggle) toggle.focus();
      }, duration);
    }

    handleSearch(query) {
      if (!query || query.length < 2) {
        const results = document.querySelector('[data-search-results]');
        if (results) results.innerHTML = '';
        return;
      }

      // Fetch predictive search results
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`)
        .then(response => response.json())
        .then(data => {
          this.displayResults(data);
        })
        .catch(err => console.error('Search error:', err));
    }

    displayResults(data) {
      const resultsContainer = document.querySelector('[data-search-results]');
      if (!resultsContainer) return;

      const products = data.resources?.results?.products || [];
      
      if (products.length === 0) {
        const msg = this.translations.search_no_results || 'Rezultatų nerasta';
        resultsContainer.innerHTML = '<p class="search-modal__results-empty">' + this.escapeHtml(msg) + '</p>';
        return;
      }

      const getProductImageUrl = (product) => {
        let url = product.featured_image || product.image;
        if (!url && product.featured_media && product.featured_media.preview_image && product.featured_media.preview_image.url)
          url = product.featured_media.preview_image.url;
        if (url && typeof url === 'object') url = url.url || url.src;
        if (!url || typeof url !== 'string') return '';
        return url.startsWith('//') ? 'https:' + url : url;
      };

      const html = `
        <ul class="search-modal__result-list" role="list">
          ${products.map(product => {
            const imgSrc = getProductImageUrl(product);
            return `
            <li class="search-modal__result">
              <a href="${product.url}" class="search-modal__result-link">
                <span class="search-modal__result-image-wrap">
                  ${imgSrc
                    ? `<img class="search-modal__result-image" src="${imgSrc}" alt="" loading="lazy" onerror="this.style.display='none';this.nextElementSibling.style.display='flex';">
                     <span class="search-modal__result-placeholder" style="display:none;" aria-hidden="true">${this.escapeHtml(this.translations.cart_no_image || 'No image')}</span>`
                    : '<span class="search-modal__result-placeholder">' + this.escapeHtml(this.translations.cart_no_image || 'No image') + '</span>'}
                </span>
                <span class="search-modal__result-info">
                  <span class="search-modal__result-title">${this.escapeHtml(product.title)}</span>
                  <span class="search-modal__result-price">${product.price || ''}</span>
                </span>
              </a>
            </li>`;
          }).join('')}
        </ul>
      `;

      resultsContainer.innerHTML = html;
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    // Cart Drawer
    bindCartDrawerEvents() {
      if (!this.cartDrawer) return;
      const openBtns = document.querySelectorAll('[data-cart-drawer-open]');
      const closeBtns = document.querySelectorAll('[data-cart-drawer-close]');
      openBtns.forEach(btn => btn.addEventListener('click', () => this.openCartDrawer()));
      closeBtns.forEach(btn => btn.addEventListener('click', () => this.closeCartDrawer()));
      this.cartDrawer.addEventListener('click', (e) => {
        const quickAdd = e.target.closest('[data-quick-add-variant]');
        if (quickAdd) {
          e.preventDefault();
          this.quickAdd(quickAdd.dataset.quickAddVariant, quickAdd);
          return;
        }
        const qtyPlus = e.target.closest('[data-cart-qty-plus]');
        if (qtyPlus) {
          e.preventDefault();
          this.cartChange(qtyPlus.dataset.cartQtyPlus, 1);
          return;
        }
        const qtyMinus = e.target.closest('[data-cart-qty-minus]');
        if (qtyMinus) {
          e.preventDefault();
          this.cartChange(qtyMinus.dataset.cartQtyMinus, -1);
          return;
        }
        const remove = e.target.closest('[data-cart-remove]');
        if (remove) {
          e.preventDefault();
          const key = remove.dataset.cartKey || remove.closest('[data-cart-item]')?.dataset?.cartKey;
          if (key) this.cartChange(key, 0);
          return;
        }
        const next = e.target.closest('[data-upsell-next]');
        if (next) {
          e.preventDefault();
          this.setUpsellIndex(1);
          return;
        }
        const prev = e.target.closest('[data-upsell-prev]');
        if (prev) {
          e.preventDefault();
          this.setUpsellIndex(0);
          return;
        }
      });
    }

    setUpsellIndex(index) {
      const track = this.cartDrawer?.querySelector('[data-cart-upsells] .cart-drawer__upsells-track');
      if (!track) return;
      const cards = track.querySelectorAll('[data-cart-upsell]');
      cards.forEach((el, i) => {
        el.classList.toggle('cart-drawer__upsell--active', i === index && !el.classList.contains('cart-drawer__upsell--in-cart'));
      });
      this.updateUpsellArrows();
    }

    updateUpsellArrows() {
      const upsells = this.cartDrawer?.querySelector('[data-cart-upsells]');
      if (!upsells) return;
      const track = upsells.querySelector('.cart-drawer__upsells-track');
      const cards = track ? Array.from(track.querySelectorAll('[data-cart-upsell]')) : [];
      const visible = cards.filter(el => !el.classList.contains('cart-drawer__upsell--in-cart'));
      const activeEl = upsells.querySelector('.cart-drawer__upsell--active');
      const activeIndex = activeEl ? parseInt(activeEl.dataset.upsellIndex, 10) : 0;
      const nextBtn = upsells.querySelector('[data-upsell-next]');
      const prevBtn = upsells.querySelector('[data-upsell-prev]');
      const onlyOneVisible = visible.length < 2;
      if (nextBtn) nextBtn.hidden = onlyOneVisible || activeIndex >= 1;
      if (prevBtn) prevBtn.hidden = onlyOneVisible || activeIndex <= 0;
    }

    updateUpsellVisibility(cart) {
      const upsells = this.cartDrawer?.querySelector('[data-cart-upsells]');
      if (!upsells) return;
      const cartProductIds = (cart.items || []).map(i => i.product_id);
      const track = upsells.querySelector('.cart-drawer__upsells-track');
      if (!track) return;
      const cards = track.querySelectorAll('[data-cart-upsell]');
      let firstVisibleIndex = null;
      cards.forEach((el, i) => {
        const productId = parseInt(el.dataset.upsellProductId, 10);
        const inCart = cartProductIds.includes(productId);
        if (inCart) el.classList.add('cart-drawer__upsell--in-cart');
        else {
          el.classList.remove('cart-drawer__upsell--in-cart');
          if (firstVisibleIndex === null) firstVisibleIndex = i;
        }
      });
      const activeEl = track.querySelector('.cart-drawer__upsell--active');
      const activeIndex = activeEl ? parseInt(activeEl.dataset.upsellIndex, 10) : 0;
      const activeInCart = activeEl && activeEl.classList.contains('cart-drawer__upsell--in-cart');
      const newIndex = activeInCart ? (firstVisibleIndex !== null ? firstVisibleIndex : 0) : activeIndex;
      cards.forEach((el, i) => el.classList.toggle('cart-drawer__upsell--active', i === newIndex && !el.classList.contains('cart-drawer__upsell--in-cart')));
      const allInCart = cards.length > 0 && Array.from(cards).every(el => el.classList.contains('cart-drawer__upsell--in-cart'));
      upsells.style.display = allInCart ? 'none' : '';
      this.updateUpsellArrows();
    }

    openCartDrawer() {
      if (!this.cartDrawer) return;
      this.cartDrawer.setAttribute('aria-hidden', 'false');
      this.body.style.overflow = 'hidden';
      this.body.style.position = 'fixed';
      this.body.style.width = '100%';
      this.body.style.top = `-${window.scrollY}px`;
      this.scrollY = window.scrollY;
      const btn = document.querySelector('[data-cart-drawer-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      this.refreshCartDrawer();
    }

    closeCartDrawer() {
      if (!this.cartDrawer) return;
      this.cartDrawer.setAttribute('aria-hidden', 'true');
      this.body.style.overflow = '';
      this.body.style.position = '';
      this.body.style.width = '';
      this.body.style.top = '';
      if (this.scrollY !== undefined) {
        window.scrollTo(0, this.scrollY);
        this.scrollY = undefined;
      }
      const btn = document.querySelector('[data-cart-drawer-open]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      document.dispatchEvent(new CustomEvent('cart-drawer:closed'));
    }

    async quickAdd(variantId, button) {
      if (!variantId) return;
      button.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        const data = await res.json();
        if (data.status && data.status !== 200) throw new Error(data.description || 'Add failed');
        await this.refreshCartDrawer();
      } catch (err) {
        console.error(err);
      }
      button.disabled = false;
    }

    async cartChange(lineKey, delta) {
      const item = this.cartDrawer.querySelector(`[data-cart-item][data-cart-key="${lineKey}"]`) || this.cartDrawer.querySelector(`[data-cart-qty-minus="${lineKey}"]`)?.closest('[data-cart-item]');
      const qtyEl = item?.querySelector('[data-cart-qty]');
      const current = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
      const newQty = delta === 0 ? 0 : Math.max(0, current + delta);
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: newQty })
        });
        const data = await res.json();
        if (data.status && data.status !== 200) throw new Error(data.description || 'Update failed');
        await this.refreshCartDrawer();
      } catch (err) {
        console.error(err);
      }
    }

    async refreshCartDrawer() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        const threshold = this.shippingThreshold;
        const progress = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        const reached = cart.total_price >= threshold;

        const bar = this.cartDrawer.querySelector('[data-cart-shipping-bar]');
        if (bar) {
          const text = bar.querySelector('.cart-drawer__shipping-text');
          const fill = bar.querySelector('[data-cart-shipping-fill]');
          const remaining = bar.querySelector('[data-cart-shipping-remaining]');
          if (text) {
            const prefix = this.translations.cart_free_shipping_prefix != null ? this.translations.cart_free_shipping_prefix : 'Add ';
            const suffix = this.translations.cart_free_shipping_suffix != null ? this.translations.cart_free_shipping_suffix : ' to unlock FREE shipping!';
            const reachedText = this.cartDrawer.dataset.cartShippingReached || this.translations.cart_free_shipping_reached || 'FREE EXPRESS SHIPPING UNLOCKED!';
            text.innerHTML = reached ? '<strong>' + reachedText + '</strong>' : prefix + '<strong data-cart-shipping-remaining>' + this.formatMoney(threshold - cart.total_price) + '</strong> ' + suffix;
          }
          if (fill) fill.style.width = progress + '%';
        }

        const body = this.cartDrawer.querySelector('[data-cart-drawer-body]');
        const itemsWrap = body?.querySelector('[data-cart-items-wrap]');
        const emptyBlock = body?.querySelector('[data-cart-empty]');
        const deliveryBlock = this.cartDrawer?.querySelector('[data-cart-delivery-block]');
        const guaranteeBlock = this.cartDrawer?.querySelector('[data-cart-guarantee-block]');
        
        const deliveryDateEl = this.cartDrawer?.querySelector('.cart-drawer__delivery-date');
        if (deliveryDateEl) {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          const options = { weekday: 'long', month: 'short', day: 'numeric' };
          deliveryDateEl.textContent = tomorrow.toLocaleDateString('en-US', options);
        }
        
        if (body && itemsWrap && emptyBlock) {
          if (cart.item_count === 0) {
            itemsWrap.style.display = 'none';
            itemsWrap.innerHTML = '';
            emptyBlock.style.display = '';
            if (deliveryBlock) deliveryBlock.style.display = 'none';
            if (guaranteeBlock) guaranteeBlock.style.display = 'none';
          } else {
            const itemStatus = this.cartDrawer.dataset.cartItemStatus || '';
            const itemsHtml = cart.items.map(item => {
              const variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
              const variant = item.variant || {};
              const alloc = item.selling_plan_allocation || null;
              
              const originalLine = item.original_line_price || 0;
              const linePrice = item.line_price || 0;
              const finalLine = item.final_line_price || 0;
              const lineDiscount = item.total_discount || 0;
              
              let compareAt = 0;
              if (alloc && alloc.compare_at_price != null && alloc.compare_at_price > (alloc.price || 0)) {
                compareAt = alloc.compare_at_price;
              } else if (variant.compare_at_price != null && variant.compare_at_price > (variant.price || linePrice / item.quantity)) {
                compareAt = variant.compare_at_price;
              }
              
              const hasCompare = compareAt > 0;
              const compareLine = hasCompare ? compareAt * item.quantity : 0;
              
              let displayOriginal;
              let displayFinal;
              
              if (hasCompare) {
                displayOriginal = compareLine;
                displayFinal = linePrice;
              } else if (lineDiscount > 0 && originalLine > linePrice) {
                displayOriginal = originalLine;
                displayFinal = linePrice;
              } else {
                displayOriginal = originalLine;
                displayFinal = linePrice;
              }
              
              const hasDiscount = displayOriginal > displayFinal;
              const saveAmount = hasDiscount ? (displayOriginal - displayFinal) : 0;
              const savePct = displayOriginal > 0 && saveAmount > 0 ? Math.round((saveAmount / displayOriginal) * 100) : 0;

              const priceText = displayFinal === 0 ? 'FREE' : this.formatMoney(displayFinal);
              let saveBadge = '';
              let priceBlock = `<span class="cart-drawer__item-price" data-cart-item-price>${priceText}</span>`;

              if (hasDiscount) {
                priceBlock = `<span class="cart-drawer__item-price-original">${this.formatMoney(displayOriginal)}</span>${priceBlock}`;
                if (saveAmount > 0) {
                  saveBadge = `<span class="cart-drawer__item-save-badge"><span class="cart-drawer__item-save-pct">${savePct}% off</span> <span class="cart-drawer__item-save">You save ${this.formatMoney(saveAmount)}</span></span>`;
                }
              }
              const variantLine = variantTitle ? this.escapeHtml(variantTitle) : '—';
              const removeBtn = `<button type="button" class="cart-drawer__item-remove" data-cart-remove data-cart-key="${item.key}" aria-label="${this.escapeHtml(this.translations.cart_remove || 'Remove')}"><span class="cart-drawer__item-remove-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></span></button>`;
              return `
              <div class="cart-drawer__item" data-cart-item data-cart-key="${item.key}">
                <div class="cart-drawer__item-left">
                  <a href="${item.url}" class="cart-drawer__item-image">
                    ${item.image ? `<img src="${item.image}" alt="${this.escapeHtml(item.title)}" loading="lazy">` : '<div class="cart-drawer__item-placeholder">' + this.escapeHtml(this.translations.cart_no_image || 'No image') + '</div>'}
                  </a>
                </div>
                <div class="cart-drawer__item-details">
                  <a href="${item.url}" class="cart-drawer__item-title">${this.escapeHtml(item.product_title)}</a>
                  <div class="cart-drawer__item-variant-block">
                    <div class="cart-drawer__item-variant-row">
                      <span class="cart-drawer__item-variant">${variantLine}</span>
                      ${removeBtn}
                    </div>
                  </div>
                </div>
                <div class="cart-drawer__item-right">
                  ${saveBadge}
                  <div class="cart-drawer__item-prices">${priceBlock}</div>
                  <div class="cart-drawer__item-qty-wrap">
                    <div class="cart-drawer__item-qty">
                      <button type="button" data-cart-qty-minus="${item.key}" aria-label="${this.escapeHtml(this.translations.cart_decrease || 'Decrease')}">−</button>
                      <span data-cart-qty>${item.quantity}</span>
                      <button type="button" data-cart-qty-plus="${item.key}" aria-label="${this.escapeHtml(this.translations.cart_increase || 'Increase')}">+</button>
                    </div>
                  </div>
                </div>
              </div>
            `;
            }).join('');
            itemsWrap.innerHTML = itemsHtml;
            itemsWrap.style.display = '';
            emptyBlock.style.display = 'none';
            if (deliveryBlock) deliveryBlock.style.display = '';
            if (guaranteeBlock) guaranteeBlock.style.display = '';
          }
        }

        const cartTitleBase = this.cartDrawer.dataset.cartTitle || this.translations.cart_title || 'Your Cart';
        const title = this.cartDrawer.querySelector('.cart-drawer__title');
        if (title) title.textContent = cartTitleBase + ' (' + cart.item_count + ')';

        const cartItemsSubtotal = (cart.items || []).reduce(function(s, i) { return s + (i.original_line_price != null ? i.original_line_price : (i.line_price || 0)); }, 0);
        let cartOriginalTotal = 0;
        (cart.items || []).forEach(item => {
          const alloc = item.selling_plan_allocation || null;
          const v = item.variant || {};
          const origLine = item.original_line_price != null ? item.original_line_price : (item.line_price || 0);
          const finLine = item.final_line_price != null ? item.final_line_price : origLine;
          let compareAt = 0;
          if (alloc && alloc.compare_at_price != null && alloc.compare_at_price > (alloc.price || 0)) {
            compareAt = alloc.compare_at_price;
          } else if (v.compare_at_price != null && v.compare_at_price > (v.price || (finLine / item.quantity))) {
            compareAt = v.compare_at_price;
          }
          if (compareAt > 0) {
            cartOriginalTotal += compareAt * item.quantity;
          } else {
            cartOriginalTotal += origLine;
          }
        });
        const cartSavings = cartOriginalTotal - cart.total_price;

        const subtotalEl = this.cartDrawer.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.total_price);
        const subtotalOriginalEl = this.cartDrawer.querySelector('[data-cart-subtotal-original]');
        if (subtotalOriginalEl) {
          if (cartOriginalTotal > cart.total_price) {
            subtotalOriginalEl.textContent = this.formatMoney(cartOriginalTotal);
            subtotalOriginalEl.style.display = '';
          } else {
            subtotalOriginalEl.style.display = 'none';
          }
        }
        const discountsWrap = this.cartDrawer.querySelector('[data-cart-discounts-wrap]');
        if (discountsWrap) {
          const discountApps = cart.discount_applications || cart.discountApplications || [];
          const comboCode = window.AVA_COMBO_DISCOUNT && window.AVA_COMBO_DISCOUNT.code && Array.isArray(window.AVA_COMBO_DISCOUNT.productIds)
            ? (cart.items || []).some(function(item) { return window.AVA_COMBO_DISCOUNT.productIds.indexOf(item.product_id) !== -1; }) ? window.AVA_COMBO_DISCOUNT.code : null
            : null;
          const hasDiscounts = cartSavings > 0 || discountApps.length > 0 || comboCode;
          discountsWrap.style.display = hasDiscounts ? '' : 'none';
          const amountEl = discountsWrap.querySelector('[data-cart-discounts-amount]');
          if (amountEl) amountEl.textContent = cartSavings > 0 ? '-' + this.formatMoney(cartSavings) : (cart.total_discount > 0 ? '-' + this.formatMoney(cart.total_discount) : '');
          const namesEl = discountsWrap.querySelector('[data-cart-discount-names]');
          const tagSvg = '<span class="cart-drawer__discount-badge-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg></span>';
          if (namesEl) {
            if (discountApps.length > 0) {
              const names = discountApps.map(function(d) { return d.title || d.code || d.key || 'Discount'; }).join(', ');
              namesEl.innerHTML = tagSvg + '<span class="cart-drawer__discount-badge-text">' + this.escapeHtml(names) + '</span>';
            } else if (comboCode) {
              namesEl.innerHTML = tagSvg + '<span class="cart-drawer__discount-badge-text">' + this.escapeHtml(comboCode) + '</span>';
            } else if (cartSavings > 0) {
              namesEl.innerHTML = tagSvg + '<span class="cart-drawer__discount-badge-text">SPECIAL COMBO DISCOUNT APPLIED</span>';
            }
          }
        }

        const checkoutLink = this.cartDrawer.querySelector('[data-cart-checkout-link]');
        const checkoutTextEl = this.cartDrawer.querySelector('[data-cart-checkout-text]');
        if (checkoutTextEl) {
          const label = checkoutLink?.dataset?.cartCheckoutLabel || this.translations.cart_checkout || 'Proceed to Checkout';
          checkoutTextEl.textContent = label + ' · ' + this.formatMoney(cart.total_price);
        }
        if (checkoutLink && window.AVA_COMBO_DISCOUNT && window.AVA_COMBO_DISCOUNT.code && Array.isArray(window.AVA_COMBO_DISCOUNT.productIds)) {
          const giftInCart = cart.items.some(item => window.AVA_COMBO_DISCOUNT.productIds.indexOf(item.product_id) !== -1);
          checkoutLink.href = giftInCart ? '/checkout?discount=' + encodeURIComponent(window.AVA_COMBO_DISCOUNT.code) : '/checkout';
        } else if (checkoutLink) {
          checkoutLink.href = '/checkout';
        }

        const badge = document.querySelector('[data-cart-count]');
        if (badge) {
          if (cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.style.display = '';
            badge.classList.remove('header__cart-badge--empty');
          } else {
            badge.textContent = '';
            badge.style.display = 'none';
            badge.classList.add('header__cart-badge--empty');
          }
        }
        this.updateUpsellVisibility(cart);
      } catch (e) { console.error(e); }
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR'
      }).format(cents / 100);
    }

    // Keyboard Events
    bindKeyboardEvents() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.drawer && this.drawer.getAttribute('aria-hidden') === 'false') this.closeDrawer();
          if (this.search && this.search.getAttribute('aria-hidden') === 'false') this.closeSearch();
          if (this.cartDrawer && this.cartDrawer.getAttribute('aria-hidden') === 'false') this.closeCartDrawer();
        }
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
          e.preventDefault();
          this.openSearch();
        }
      });
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new HeaderController());
  } else {
    new HeaderController();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  // Keep empty for compatibility

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-items"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.recommended-carousel');
    if (!section) return;
    
    var track = section.querySelector('[data-carousel-track]');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var slides = track.querySelectorAll('.recommended-carousel__slide');
    
    if (!track || slides.length === 0) return;
    
    var currentIndex = 0;
    var autoSlideInterval;
    var slidesPerView = 4;
    var maxIndex = Math.max(0, slides.length - slidesPerView);
    
    function updateSlidesPerView() {
      if (window.innerWidth <= 640) {
        slidesPerView = 1;
      } else if (window.innerWidth <= 768) {
        slidesPerView = 2;
      } else if (window.innerWidth <= 1200) {
        slidesPerView = 3;
      } else {
        slidesPerView = 4;
      }
      maxIndex = Math.max(0, slides.length - slidesPerView);
      currentIndex = Math.min(currentIndex, maxIndex);
      updateCarousel();
    }
    
    function updateCarousel() {
      var slideWidth = slides[0].offsetWidth;
      var gap = 5;
      var offset = -(currentIndex * (slideWidth + gap));
      track.style.transform = 'translateX(' + offset + 'px)';
      
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }
    
    function goToNext() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      } else {
        currentIndex = 0;
        updateCarousel();
      }
    }
    
    function goToPrev() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }
    
    function startAutoSlide() {
      stopAutoSlide();
      autoSlideInterval = setInterval(function() {
        goToNext();
      }, 5000);
    }
    
    function stopAutoSlide() {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
      }
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        goToPrev();
        stopAutoSlide();
        startAutoSlide();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        goToNext();
        stopAutoSlide();
        startAutoSlide();
      });
    }
    
    window.addEventListener('resize', updateSlidesPerView);
    updateSlidesPerView();
    
    if (slides.length > slidesPerView) {
      startAutoSlide();
    }
    
    section.addEventListener('mouseenter', stopAutoSlide);
    section.addEventListener('mouseleave', function() {
      if (slides.length > slidesPerView) {
        startAutoSlide();
      }
    });
    
    // Color swatch functionality
    var hasHover = window.matchMedia('(hover: hover)').matches;
    function getColorKey(str) { return (str || '').trim().toLowerCase(); }
    function getImagesByColor(wrapper) {
      var main = {}, hover = {};
      wrapper.querySelectorAll('.collection-grid__image--color[data-color][data-role]').forEach(function(img) {
        var key = getColorKey(img.getAttribute('data-color'));
        var role = (img.getAttribute('data-role') || '').trim();
        if (role === 'main') main[key] = img;
        if (role === 'hover') hover[key] = img;
      });
      return { main: main, hover: hover };
    }
    function setVisible(wrapper, imagesByColor, displayColor, useHover) {
      var key = getColorKey(displayColor);
      var mainEl = imagesByColor.main[key];
      var hoverEl = imagesByColor.hover[key];
      wrapper.querySelectorAll('.collection-grid__image--color').forEach(function(img) {
        img.classList.remove('collection-grid__image--visible');
      });
      if (useHover && hoverEl) {
        hoverEl.classList.add('collection-grid__image--visible');
      } else if (mainEl) {
        mainEl.classList.add('collection-grid__image--visible');
      }
    }
    section.querySelectorAll('.collection-grid__item--has-colors').forEach(function(item) {
      var wrapper = item.querySelector('.collection-grid__image-wrapper');
      var swatchesEl = item.querySelector('.collection-grid__swatches');
      if (!wrapper || !swatchesEl) return;
      var imagesByColor = getImagesByColor(wrapper);
      var firstMainEl = wrapper.querySelector('.collection-grid__image--color[data-role="main"]');
      var firstColorKey = firstMainEl ? getColorKey(firstMainEl.getAttribute('data-color')) : (Object.keys(imagesByColor.main)[0] || null);
      var activeBtn = swatchesEl.querySelector('.collection-grid__swatch--active');
      var selectedColor = item.getAttribute('data-selected-color') || (activeBtn ? activeBtn.getAttribute('data-color') : '') || '';
      var previewColor = null;
      function getDisplayColor() { return previewColor || selectedColor || firstColorKey || ''; }
      function showMain() { setVisible(wrapper, imagesByColor, getDisplayColor(), false); }
      function showHover() { setVisible(wrapper, imagesByColor, getDisplayColor(), true); }
      setVisible(wrapper, imagesByColor, selectedColor || firstColorKey, false);
      swatchesEl.querySelectorAll('.collection-grid__swatch').forEach(function(btn) {
        var color = btn.getAttribute('data-color');
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = btn.getAttribute('data-variant-id');
          var url = item.href || '';
          if (variantId && url) {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + variantId;
            window.location.href = url;
            return;
          }
          selectedColor = color;
          item.setAttribute('data-selected-color', color);
          previewColor = null;
          setVisible(wrapper, imagesByColor, color, false);
          swatchesEl.querySelectorAll('.collection-grid__swatch').forEach(function(b) {
            b.classList.remove('collection-grid__swatch--active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('collection-grid__swatch--active');
          btn.setAttribute('aria-pressed', 'true');
        });
        if (hasHover) {
          btn.addEventListener('mouseenter', function() {
            previewColor = color;
            setVisible(wrapper, imagesByColor, color, false);
          });
          btn.addEventListener('mouseleave', function() {
            previewColor = null;
            showMain();
          });
        }
      });
      if (hasHover) {
        wrapper.addEventListener('mouseenter', function() { showHover(); });
        wrapper.addEventListener('mouseleave', function() { showMain(); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
